import React from 'react';
import { generateContent, generateCss, generateStyle } from '../../functions/sortableFunctions';
const Html = ({ block, ...props }: any) => {
    return (
        <React.Fragment>
            {
                React.createElement(
                    block.data?.type ?? "article",
                    {
                        id: block.id,
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            }
                        }),
                        style: generateStyle({
                            props: {
                                ...props,
                                block
                            }
                        }),
                        dangerouslySetInnerHTML: {
                            __html: generateContent({
                                props: {
                                    ...props,
                                    block
                                },
                                html: true
                            })
                        }
                    },
                    null
                )
            }
        </React.Fragment>

    )
}
export default Html;